// Observable class extensions
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/merge';

// Observable operators
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';



// WEBPACK FOOTER //
// /srv/src/rxjs-imports.ts